'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { map } from 'rxjs/operators/map';
import { ContentTypes } from '../constants/base';
import Template from '../models/Template';
const generateUrl = (contentType, id, layoutId, templatePath) => contentType === ContentTypes.BLOG_POST && layoutId ? `designmanager/v1/layouts/unified/${layoutId}` : `designmanager/v1/templates/by-path/${templatePath}`;
export default {
  fetchTemplate(contentType, id, layoutId, templatePath) {
    return http.get(generateUrl(contentType, id, layoutId, templatePath)).pipe(map(response => Template.fromJS(contentType, response)));
  }
};